"use strict";

(function () {
  'use strict'; //Public Factory

  angular.module('lr.Utils').factory('Utils', Utils);
  Utils.$inject = ['$filter', '$window', '$timeout'];
  /* @ngInject */

  function Utils($filter, $window, $timeout) {
    var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
    /**
     * OptimizedScroll
     */

    var OptimizedScroll = {
      callbacks: [],
      running: false,
      window: angular.element($window)
    };

    OptimizedScroll.scroll = function scroll() {
      if (!OptimizedScroll.running) {
        OptimizedScroll.running = true;

        if (requestAnimationFrame) {
          requestAnimationFrame(OptimizedScroll.runCallbacks);
        } else {
          $timeout(OptimizedScroll.runCallbacks, 66);
        }
      }
    };

    OptimizedScroll.runCallbacks = function runCallbacks() {
      OptimizedScroll.callbacks.forEach(function (callback) {
        callback();
      });
      OptimizedScroll.running = false;
    };

    OptimizedScroll.addCallback = function addCallback(callback) {
      if (callback) {
        OptimizedScroll.callbacks.push(callback);
      }
    };

    OptimizedScroll.api = {
      init: function init(callback) {
        OptimizedScroll.window.bind('scroll', OptimizedScroll.scroll);
        OptimizedScroll.addCallback(callback);
      },
      addCallback: function addCallback(callback) {
        OptimizedScroll.addCallback(callback);
      }
    };
    /**
     *
     *
     */

    var pubsub = {};
    var topics = {}; // An topic identifier

    var subUid = -1;

    pubsub.publish = function (topic, args) {
      if (!topics[topic]) {
        return false;
      }

      var subscribers = topics[topic];
      var len = subscribers ? subscribers.length : 0;

      while (len--) {
        subscribers[len].func(topic, args); //console.log('topic: ' + topic + ' args : ' + JSON.stringify(args));
      }

      return this;
    };

    pubsub.hasEvent = function (event) {
      return topics[event];
    };

    pubsub.subscribe = function (topic, func) {
      if (!topics[topic]) {
        topics[topic] = [];
      }

      var token = (++subUid).toString();
      topics[topic].push({
        token: token,
        func: func
      });
      return token;
    };

    pubsub.unsubscribe = function (token) {
      for (var m in topics) {
        if (topics[m]) {
          for (var i = 0, j = topics[m].length; i < j; i++) {
            if (topics[m][i].token === token) {
              topics[m].splice(i, 1);
              return token;
            }
          }
        }
      }

      return this;
    };
    /**
     * DateKeeper
     */


    var DateKeeper = {};
    DateKeeper.todayDate = new Date();
    DateKeeper.event = 'date:changed';

    DateKeeper.getDate = function () {
      return this.todayDate;
    };

    DateKeeper.getToday = function () {
      return new Date();
    };

    DateKeeper.goToday = function () {
      this.todayDate = new Date();
      DateKeeper.dateChanged();
    };

    DateKeeper.nextDay = function () {
      this.todayDate.setDate(this.todayDate.getDate() + 1);
      DateKeeper.dateChanged();
    };

    DateKeeper.previousDay = function () {
      this.todayDate.setDate(this.todayDate.getDate() + -1);
      DateKeeper.dateChanged();
    };

    DateKeeper.dateChanged = function () {
      pubsub.publish(DateKeeper.event, this.todayDate);
    };

    var service = {
      lrDateFormat: lrDateFormat,
      DateKeeper: DateKeeper,
      Publisher: pubsub,
      validLatLong: validLatLong,
      OptimizedScroll: OptimizedScroll.api
    };
    return service; ////////////////

    function lrDateFormat(date) {
      return $filter('date')(date, 'MM/dd/yyyy');
    }

    function validLatLong(lat, _long) {
      return !isNaN(parseFloat(lat)) || !isNaN(parseFloat(_long));
    }
  }
})();